import SlInput from "@shoelace-style/shoelace/dist/components/input/input";

export function focusAndSelect(inp: SlInput | undefined) {
  if (!inp) return;
  inp.focus();
  inp.select();
}
